import { VApp } from 'vuetify/lib/components/VApp';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,{attrs:{"id":"app"}},[_c('router-view'),_c(VBottomSheet,{model:{value:(_vm.prompt),callback:function ($$v) {_vm.prompt=$$v},expression:"prompt"}},[_c(VSheet,{staticClass:"text-center",attrs:{"height":"150px"}},[_c(VBtn,{staticClass:"mt-6",attrs:{"text":"","color":"red"},on:{"click":_vm.update}},[_vm._v(" Update ")]),_c('div',{staticClass:"py-3"},[_vm._v(" A new version is found. Refresh to load it! ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }